import { ShaderMaterial, Uniform, Vector2, Vector3, Vector4 } from 'three'

import fragment from './shader-fragment.glsl'
import vertex from './shader-vertex.glsl'

export default class RGBOffsetMaterial extends ShaderMaterial
{
    constructor(options = {})
    {
        super({
            type: 'RGBOffsetMaterial',

            uniforms:
            {
                tDiffuse: new Uniform(null),
                uResolution: new Uniform(new Vector2()),
                uRadialDumping: new Uniform(new Vector4()),
                uStrength: new Uniform(0),
                uTeint: new Uniform(new Vector3())
            },

            fragmentShader: fragment,
            vertexShader: vertex,

            depthWrite: false,
            depthTest: false
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/app-experience/Experience/Passes/RGBOffsetPass/Material.js